import { render, staticRenderFns } from "./PsrHeaderInitial.vue?vue&type=template&id=41a23d45&scoped=true&"
import script from "./PsrHeaderInitial.vue?vue&type=script&lang=js&"
export * from "./PsrHeaderInitial.vue?vue&type=script&lang=js&"
import style0 from "./PsrHeaderInitial.vue?vue&type=style&index=0&id=41a23d45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a23d45",
  null
  
)

export default component.exports